import { Component, Input } from '@angular/core';
import { SalesChargeBreakPoint } from '@models';
import { FundId } from '@products/types';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';

@Component({
  selector: 'ft-pop-sales-charge-breakpoints',
  templateUrl: './pop-sales-charge-breakpoints.component.html',
  styleUrls: ['./pop-sales-charge-breakpoints.component.scss'],
})
export class PopSalesChargeBreakpointsComponent extends BaseTableResponsiveComponent {
  @Input() salesChargeBreakPointsData: SalesChargeBreakPoint[];
  @Input() fundId: FundId;
}
